// extracted by mini-css-extract-plugin
export default {"root":"OHUtJcDwrg","recipientTitle":"yK0IrzgqY9"};